import script from "./ForecastDiffLastMonthTableHead.vue?vue&type=script&lang=ts&setup=true"
export * from "./ForecastDiffLastMonthTableHead.vue?vue&type=script&lang=ts&setup=true"

import "./ForecastDiffLastMonthTableHead.vue?vue&type=style&index=0&id=849adbd8&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.2.41_vue@3.5.14_typescript@5.5.4__webpack@5.99.8/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-849adbd8"]])

export default __exports__